import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '../FIELD__base';

export function DECORATOR__data__reset_if_not_linked(method_original: any, context: ClassMethodDecoratorContext) {
  // Return a new function that replaces the old one
  return function (this: FIELD__base, ...args: any[]) {
    assert_instanceof(this, FIELD__base);

    this.meta.data__reset_if_not_linked = true;

    return method_original.apply(this, args);
  };
}
